import { PORTFOLIO_WEBSITE_FILES } from './portfolio-website/files';
import { SAAS_LANDING_FILES } from './saas-landing/files';
import { ECOMMERCE_STORE_FILES } from './ecommerce-store/files';
import { TASK_MANAGEMENT_DASHBOARD_FILES } from './task-management-dashboard/files';
import { RESTAURANT_WEBSITE_FILES } from './restaurant-website/files';
import { HEALTHCARE_DASHBOARD_FILES } from './healthcare-dashboard/files';
import { FITNESS_GYM_WEBSITE_FILES } from './fitness-gym-website/files';
import { REAL_ESTATE_LISTING_FILES } from './real-estate-listing/files';
import { BLOG_CMS_FILES } from './blog-cms/files';
import { ADMIN_DASHBOARD_FILES } from './admin-dashboard/files';

export const TEMPLATE_TYPES = {
  PORTFOLIO: 'portfolio-website',
  SAAS: 'saas-landing',
  ECOMMERCE: 'ecommerce-store',
  TASK_MANAGEMENT: 'task-management-dashboard',
  RESTAURANT: 'restaurant-website',
  HEALTHCARE: 'healthcare-dashboard',
  FITNESS: 'fitness-gym-website',
  REAL_ESTATE: 'real-estate-listing',
  BLOG_CMS: 'blog-cms',
  ADMIN: 'admin-dashboard',
};

const TEMPLATE_FILE_MAP = {
  [TEMPLATE_TYPES.PORTFOLIO]: PORTFOLIO_WEBSITE_FILES,
  [TEMPLATE_TYPES.SAAS]: SAAS_LANDING_FILES,
  [TEMPLATE_TYPES.ECOMMERCE]: ECOMMERCE_STORE_FILES,
  [TEMPLATE_TYPES.TASK_MANAGEMENT]: TASK_MANAGEMENT_DASHBOARD_FILES,
  [TEMPLATE_TYPES.RESTAURANT]: RESTAURANT_WEBSITE_FILES,
  [TEMPLATE_TYPES.HEALTHCARE]: HEALTHCARE_DASHBOARD_FILES,
  [TEMPLATE_TYPES.FITNESS]: FITNESS_GYM_WEBSITE_FILES,
  [TEMPLATE_TYPES.REAL_ESTATE]: REAL_ESTATE_LISTING_FILES,
  [TEMPLATE_TYPES.BLOG_CMS]: BLOG_CMS_FILES,
  [TEMPLATE_TYPES.ADMIN]: ADMIN_DASHBOARD_FILES,
};

/** Returns a shallow copy of starter files for the given template type, or null. */
export function getTemplateFiles(templateType) {
  const files = TEMPLATE_FILE_MAP[templateType];
  if (!files) return null;
  return { ...files };
}

export function hasTemplateFiles(templateType) {
  const files = TEMPLATE_FILE_MAP[templateType];
  return !!(files && Object.keys(files).length > 0);
}

/** Map gallery/modal titles → internal template type ids */
export const TEMPLATE_TITLE_TO_TYPE = {
  'SaaS Landing Page': TEMPLATE_TYPES.SAAS,
  'Portfolio Website': TEMPLATE_TYPES.PORTFOLIO,
  'E-Commerce Store': TEMPLATE_TYPES.ECOMMERCE,
  'Task Management Dashboard': TEMPLATE_TYPES.TASK_MANAGEMENT,
  'Restaurant Website': TEMPLATE_TYPES.RESTAURANT,
  'Healthcare Dashboard': TEMPLATE_TYPES.HEALTHCARE,
  'Fitness/Gym Website': TEMPLATE_TYPES.FITNESS,
  'Real Estate Listing': TEMPLATE_TYPES.REAL_ESTATE,
  'Blog/CMS': TEMPLATE_TYPES.BLOG_CMS,
  'Admin Dashboard': TEMPLATE_TYPES.ADMIN,
};

export function resolveTemplateType(titleOrType) {
  if (!titleOrType) return null;
  if (TEMPLATE_FILE_MAP[titleOrType]) return titleOrType;
  return TEMPLATE_TITLE_TO_TYPE[titleOrType] || null;
}
